import styled from '@emotion/styled';
import {
  Button,
  DialogActions,
  DialogContent as _DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { ClassAttributes, createElement, FC, MouseEvent, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import YahooAdAccount from '../../../entity/YahooAdAccount';
import theme from '../../../theme';
import { SPACING_REGULAR } from '../../constant/spacing';
import { context as stateContext } from '../../context/state';
import mq from '../../styleUtility/mediaquery';
import Dialog from '../primitive/DialogWithPadding';
import YahooAdAccountList from './YahooAdAccountList';

type Props = ClassAttributes<HTMLElement> & {
  open: boolean;
  onRequestSendingCreative: (e: MouseEvent<HTMLElement>, yahooAdAccount: YahooAdAccount) => void;
  onRequestClose: () => void;
  className?: string;
};

const CreativeSendingToYahooDialog: FC<Props> = ({ open, onRequestSendingCreative, onRequestClose, className }) => {
  const state = useContext(stateContext);
  const [selectedAdAccount, setSelectedAdAccount] = useState<YahooAdAccount | null>(null);
  const yahooAdAccounts = state.integratedYahooAdAccounts.adAccounts;
  const onClickAdAccount = (_: any, selected: YahooAdAccount) => {
    setSelectedAdAccount(selected);
  };
  const onClickSendButton = (e: any) => {
    onRequestSendingCreative(e, selectedAdAccount!);
    onRequestClose();
  };

  return (
    <Dialog open={open} onRequestClose={onRequestClose} className={className} maxWidth="md">
      <DialogTitle disableTypography>
        <Title variant="h6">
          <FormattedMessage id="creative_sending_to_yahoo_dialog.title" />
        </Title>
        <Description variant="body2">
          <FormattedMessage id="creative_sending_to_yahoo_dialog.description" />
        </Description>
      </DialogTitle>

      <ContentLayout>
        <DialogContent>
          {yahooAdAccounts.size > 0 ? (
            <YahooAdAccountList
              yahooAdAccounts={yahooAdAccounts}
              selected={selectedAdAccount}
              onClick={onClickAdAccount}
            />
          ) : (
            <Caution>
              <FormattedMessage id="creative_sending_to_yahoo_dialog.message" />
            </Caution>
          )}
        </DialogContent>
      </ContentLayout>

      <DialogActions>
        <Button disabled={!selectedAdAccount} onClick={onClickSendButton}>
          <FormattedMessage id="creative_sending_to_facebook_dialog.send" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Title = styled(Typography)({
  [mq('sp')]: {
    fontSize: theme.typography.subtitle1.fontSize,
  },
});

const Description = styled(DialogContentText)({
  marginTop: SPACING_REGULAR,
  [mq('sp')]: {
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
  },
});

const ContentLayout = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const DialogContent = styled(_DialogContent)({
  paddingTop: '0 !important',
  paddingBottom: 0,
  maxWidth: 750,
});

const Caution = styled('div')({
  color: '#ff0000',
  fontWeight: 'bold',
});

export default CreativeSendingToYahooDialog;
